import { createAction } from '../../utils';

export const RETRIEVE_ORDER_STATUS = 'RETRIEVE_ORDER_STATUS';
export const SET_ORDER_STATUS_TO_STORE = 'SET_ORDER_STATUS_TO_STORE';
export const SET_ORDER_STATUS_FROM_GOC = 'SET_ORDER_STATUS_FROM_GOC';
export const SET_ORDER_STATUS_FROM_ORDER_SUMMARY = 'SET_ORDER_STATUS_FROM_ORDER_SUMMARY';
export const SET_ORDER_STATUS_FROM_TRACKING_EVENTS = 'SET_ORDER_STATUS_FROM_TRACKING_EVENTS';

export const retrieveOrderStatus = createAction(RETRIEVE_ORDER_STATUS);
export const setOrderStatusToStore = createAction(SET_ORDER_STATUS_TO_STORE);
export const setOrderStatusFromGOC = createAction(SET_ORDER_STATUS_FROM_GOC);
export const setOrderStatusFromOrderSummary = createAction(SET_ORDER_STATUS_FROM_ORDER_SUMMARY);
export const setOrderStatusFromTrackingEvents = createAction(SET_ORDER_STATUS_FROM_TRACKING_EVENTS);
